import { useEffect, useState } from 'react';

// graphql
import { PageInfo, useTerminalBalanceTransfersQuery, useTerminalBalanceWithdrawalsQuery } from '@/generated/graphql';

// material ui
import { Grid } from '@mui/material';

// interfaces
import {
  ITerminalBalanceTransferQueryVariable,
  mapGQLTerminalBalanceTransfer,
  ITerminalBalanceTransferTable,
  ITerminalBalanceWithdrawalTable,
  ITerminalBalanceWithdrawalQueryVariable,
  mapGQLTerminalBalanceWithdrawal,
} from '@/shared/interfaces';

interface IProps {
  refetchTerminalChipsQuery: boolean;
  setRefetchTerminalChipsQuery: React.Dispatch<React.SetStateAction<boolean>>;
}

// components
import { TableTerminalBalanceTransfers } from './terminal-balance-transfer-table';
import { TableTerminalBalanceWithdrawals } from './terminal-balance-withdrawal-table';

export const TerminalBalance = ({ refetchTerminalChipsQuery, setRefetchTerminalChipsQuery }: IProps) => {
  const [terminalBalTransfers, setTerminalBalTransfers] = useState<ITerminalBalanceTransferTable[]>([]);
  const [terminalBalWithdrawals, setTerminalBalWithdrawals] = useState<ITerminalBalanceWithdrawalTable[]>([]);

  const [terminalBalTransfersPageInfo, setTerminalBalTransfersPageInfo] = useState<PageInfo>();
  const [terminalBalTransfersTotalCount, setTerminalBalTransfersTotalCount] = useState<number>(0);
  const [terminalBalWithdrawalsPageInfo, setTerminalBalWithdrawalsPageInfo] = useState<PageInfo>();
  const [terminalBalWithdrawalsTotalCount, setTerminalBalWithdrawalsTotalCount] = useState<number>(0);

  const [terminalBalanceTransfersQueryVariable, setTerminalBalanceTransfersQueryVariable] = useState<ITerminalBalanceTransferQueryVariable>(
    {
      first: 25,
    },
  );
  const [terminalBalanceWithdrawalsQueryVariable, setTerminalBalanceWithdrawalsQueryVariable] =
    useState<ITerminalBalanceWithdrawalQueryVariable>({
      first: 25,
    });

  const terminalBalanceTransfersQuery = useTerminalBalanceTransfersQuery({
    variables: terminalBalanceTransfersQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.terminalBalanceTransfers.nodes.map((x) => mapGQLTerminalBalanceTransfer(x));

      const mappedTableData: ITerminalBalanceTransferTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        createdAt: x.createdAt,
        username: x.admin.user.username,
      }));

      setTimeout(() => {
        setTerminalBalTransfers(mappedTableData);
        setTerminalBalTransfersPageInfo(data.terminalBalanceTransfers.pageInfo);
        setTerminalBalTransfersTotalCount(data.terminalBalanceTransfers.totalCount);
      }, 100);
    },
  });

  const terminalBalanceWithdrawalsQuery = useTerminalBalanceWithdrawalsQuery({
    variables: terminalBalanceWithdrawalsQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.terminalBalanceWithdrawals.nodes.map((x) => mapGQLTerminalBalanceWithdrawal(x));

      const mappedTableData: ITerminalBalanceWithdrawalTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        createdAt: x.createdAt,
        username: x.admin.user.username,
      }));

      setTimeout(() => {
        setTerminalBalWithdrawals(mappedTableData);
        setTerminalBalWithdrawalsPageInfo(data.terminalBalanceWithdrawals.pageInfo);
        setTerminalBalWithdrawalsTotalCount(data.terminalBalanceWithdrawals.totalCount);
      }, 100);
    },
  });

  useEffect(() => {
    if (refetchTerminalChipsQuery === true) {
      console.log('REFETCH');
      setRefetchTerminalChipsQuery(false);
      terminalBalanceTransfersQuery.refetch();
      terminalBalanceWithdrawalsQuery.refetch();
    }
  }, [refetchTerminalChipsQuery]);

  return (
    <>
      <Grid container spacing={2} px={2}>
        <Grid size={6}>
          <TableTerminalBalanceTransfers
            rows={terminalBalTransfers}
            setTerminalBalanceTransferQueryVariable={setTerminalBalanceTransfersQueryVariable}
            terminalBalanceTransferQueryVariable={terminalBalanceTransfersQueryVariable}
            totalCount={terminalBalTransfersTotalCount}
            pageInfo={terminalBalTransfersPageInfo}
            getTerminalBalanceTransferLoading={terminalBalanceTransfersQuery.loading}
          />
        </Grid>
        <Grid size={6}>
          <TableTerminalBalanceWithdrawals
            rows={terminalBalWithdrawals}
            setTerminalBalanceWithdrawalQueryVariable={setTerminalBalanceWithdrawalsQueryVariable}
            terminalBalanceWithdrawalQueryVariable={terminalBalanceWithdrawalsQueryVariable}
            totalCount={terminalBalWithdrawalsTotalCount}
            pageInfo={terminalBalWithdrawalsPageInfo}
            getTerminalBalanceWithdrawalLoading={terminalBalanceWithdrawalsQuery.loading}
          />
        </Grid>
      </Grid>
    </>
  );
};
